import React from 'react';
import PropTypes from 'prop-types';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';

export function FiltersDrawer({ children, isOpen, toggle, dataTrackingParent }) {
  return (
    <DrawerV2
      isOpen={isOpen}
      side="bottom"
      size="small"
      toggle={toggle}
      classNames={{
        drawerContent: 'border-0 h-100 overflow-hidden rounded-bottom-0 rounded-top-5',
        drawerContainer: 'h-100 pt-2 modal-dialog-scrollable',
      }}
      data-tracking-parent={dataTrackingParent}
    >
      {children}
    </DrawerV2>
  );
}

FiltersDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  dataTrackingParent: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
